module.exports = __webpack_public_path__ + "img/201611-2-768x1024.9f0c7363.jpg";